import AuthApi from "@/config/api/auth.js";
import AuthEorrorCode from "@/config/api/auth-error-code.js";
import Config from "@/config/Config";
import ValidationUtil from "@/utils/ValidationUtil.js";
import VueCookies from "vue-cookies";
import { GUIDE_KEY, COOKIE_KEY, SERVICE_CODE, ENCRYPTION_VERSION } from "@/utils/Constants";
import CommonUtil from "@/utils/CommonUtil";
import commonUtil from "@/utils/CommonUtil";

export default {
  state: {
    serviceInfo: {
      hasServiceInit: false,
      deviceType: "",
      serviceCode: "",
      clientId: "",
      redirectUrl: ""
    },
    loginCallbackUrl: "",
    // referrerUrl: "",
    clientInfo: {},
    sessionToken: "",
    signinReturnCode: 0,
    createTokenReturnCode: 0,
    authInfo: {
      //통합
      access_token: "",
      refresh_token: "",
      expires_in: "",
      refresh_token_expires_in: "",
      // etoos cookie 생성용 info start
      authPortalMemNo: "",
      authMemNo: "",
      authSessionId: "",
      authMemEmailId: "",
      authMemMobileId: "",
      authMemNm: "",
      authAuthKey: "",
      authSocialType: "",
      authLoginDt: "",
      authEmail: "",
      authPhone: "",
      authFirstIdType: "",
      authMemId: "",
      authEciIsAgree: "",
      // cookie 생성용 end
      // zocbo cookie info start
      authZocboNo: "",
      authZocboId: "",
      authZocboSso: "",
      // zocbo cookie end
      authAllowLoginKey: "", // 디온 중복 로그인 제한 코드
      isProfileRequired: false
    },
    serviceAuthInfo: {
      //서비스
      hasLogin: false,
      access_token: "",
      refresh_token: "",
      expires_in: "",
      refresh_token_expires_in: ""
    },
    authReturnData: {
      code: 0,
      message: "",
      value: {}
    },
    signinInfo: {
      branch_type: "",
      type: ""
    },
    enableSignInWithApple: true, //ios 로그인 판단 여부
    accountCode: "" // 로그인 시 /signin/account 응답 code값
  },
  getters: {
    getXClientInfo: (state) => {
      const clientInfo = state.clientInfo;
      const clientInfoAll = Config.CLIENT_INFO;
      const type = clientInfo.TYPE ?? "WEB";
      const serviceCode = "SVC001"; ///통합
      const xClientInfo = clientInfoAll.filter((e) => e.SERVICE_CODE === serviceCode)[0];
      const info = xClientInfo[type];
      info.SERVICE_NAME = xClientInfo.SERVICE_NAME;
      info.SERVICE_CODE = xClientInfo.SERVICE_CODE;
      info.SERVICE_ID = xClientInfo.SERVICE_ID;
      return info;
    },
    getDeviceType: (state) => {
      return state.serviceInfo.deviceType;
    },
    getOSCode: (state) => {
      const deviceType = state.serviceInfo.deviceType;
      if (deviceType === "android") {
        return "OSC002";
      } else if (deviceType === "ios") {
        return "OSC003";
      } else {
        return "OSC001";
      }
    },
    clientInfo: (state) => {
      return state.clientInfo;
    },
    errorMessageInfo: () => (errorCode) => {
      return AuthEorrorCode.filter(function (obj) {
        return obj.code === errorCode;
      });
    },
    getRandomString: () => {
      let text = "";
      const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      const textLength = 12;

      for (let i = 0; i < textLength; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      return text;
    },
    getAccountIdTypeCheck: () => (userId) => {
      if (ValidationUtil.numberValidation(userId)) {
        return Config.VERIFY_SEND_TYPE.PHONE;
      } else if (ValidationUtil.emailValidation(userId)) {
        return Config.VERIFY_SEND_TYPE.EMAIL;
      }
    },
    getServiceAuthInfo: (state) => {
      return state.serviceAuthInfo;
    },
    getAuthCallbackUrl: (state) => {
      return state.loginCallbackUrl;
    }
  },
  mutations: {
    SETTING_CALLBACK_URL(state, url) {
      state.loginCallbackUrl = url;
    },
    SETTING_ENABLED_APPLE_SIGNIN(state, enabled) {
      let value = enabled;
      if (value === "false") {
        value = false;
      }
      state.enableSignInWithApple = value;
    },
    SETTING_SERVICE_INFO(state) {
      const urlSearch = new URLSearchParams(location.search);
      const clientId = urlSearch.get(GUIDE_KEY.GUIDE_CLIENT_ID); //각 서비스에서 넘겨 받음
      const deviceType = urlSearch.get(GUIDE_KEY.GUIDE_DEVICE_TYPE);
      const loginUrl = urlSearch.get(GUIDE_KEY.GUIDE_LOGIN_URL);

      state.serviceInfo.hasServiceInit = true;
      if (clientId !== null) state.serviceInfo.clientId = clientId;

      // 앱환경에서 로그인, 마이페이지 호출 시 deviceType이 없기때문에 store deviceType이 없으면 설정
      if (CommonUtil.isEmpty(state.serviceInfo.deviceType)) {
        state.serviceInfo.deviceType = deviceType ?? Config.DEVICE_TYPE.PC;
      }

      const clientInfoArray = Config.CLIENT_INFO;

      //이투스 정보 체크 start
      const etoosInfosIdx = Config.ETOOS_INFO.WEB.ID.findIndex((e) => e === clientId);

      if (etoosInfosIdx > -1) {
        const info = clientInfoArray.filter((e) => e.SERVICE_CODE === SERVICE_CODE.ETOOS)[0];
        info.ID = clientId;

        // 비상교육 일 때 조건
        if (clientId === Config.VISANG_INFO.CLIENT_ID_NON_LIVE) {
          info.SECRET = Config.VISANG_INFO.CLIENT_SECRET_NON_LIVE;
        } else if (clientId === Config.VISANG_INFO.CLIENT_ID_LIVE) {
          info.SECRET = Config.VISANG_INFO.CLIENT_SECRET_LIVE;
        } else {
          info.SECRET = Config.ETOOS_INFO.WEB.SECRET[etoosInfosIdx];
        }

        info.LOGIN_URL = loginUrl ?? Config.ETOOS_INFO.WEB.LOGIN_URL[etoosInfosIdx];
        info.REDIERCT_URL = Config.ETOOS_INFO.WEB.REDIERCT_URL[etoosInfosIdx];
        state.clientInfo = info;
        state.serviceInfo.redirectUrl = info.REDIRECT_URL;
        return;
      }
      //이투스 정보 체크 end

      //이투스 ECI 정보 체크 start
      const etoosEciInfosIdx = Config.ETOOS_ECI_INFO.WEB.ID.findIndex((e) => e === clientId);
      if (etoosEciInfosIdx > -1) {
        const info = clientInfoArray.filter((e) => e.SERVICE_CODE === SERVICE_CODE.ETOOS)[0];
        info.SERVICE_CODE = SERVICE_CODE.ETOOS_ECI; //이투스와 정보는 동일하고 serviceCode만 달라짐
        info.ID = clientId;
        info.SECRET = Config.ETOOS_ECI_INFO.WEB.SECRET[etoosEciInfosIdx];
        info.LOGIN_URL = loginUrl ?? Config.ETOOS_ECI_INFO.WEB.LOGIN_URL[etoosEciInfosIdx];
        info.REDIERCT_URL = Config.ETOOS_ECI_INFO.WEB.REDIERCT_URL[etoosEciInfosIdx];
        state.clientInfo = info;
        state.serviceInfo.redirectUrl = info.REDIRECT_URL;
        return;
      }
      //이투스 ECI 정보 체크 end

      const currentClientInfo = clientInfoArray.filter(
        (e) => e.WEB.ID === clientId || e.MOBILE.ID === clientId || e.APP.ID === clientId
      );

      if (currentClientInfo.length > 0) {
        const info = currentClientInfo[0];
        // state.loginCallbackUrl = loginUrl;
        // if (info.SERVICE_CODE === SERVICE_CODE.SKYGO) {
        //   state.loginCallbackUrl = info.LOGIN_URL;
        // }
        info.SERVICE_CODE = currentClientInfo[0].SERVICE_CODE;
        state.serviceInfo.redirectUrl = info.REDIRECT_URL;

        switch (clientId) {
          case info.WEB.ID:
            info.TYPE = "WEB";
            info.ID = info.WEB.ID;
            info.SECRET = info.WEB.SECRET;
            break;
          case info.MOBILE.ID:
            info.TYPE = "MOBILE";
            info.ID = info.MOBILE.ID;
            info.SECRET = info.MOBILE.SECRET;
            break;
          case info.APP.ID:
            info.TYPE = "APP";
            info.ID = info.APP.ID;
            info.SECRET = info.APP.SECRET;
            // state.referrerUrl = info.APP.REFEFFER_URL;
            break;
        }

        state.clientInfo = info;
      }
    },
    SETTING_SESSION_TOKEN(state, sessionToken) {
      state.sessionToken = sessionToken;
    },
    SETTING_SIGNIN_INFO(state, signinInfo) {
      state.signinInfo = signinInfo;
    },
    INIT_API_RETURN(state) {
      state.authReturnData.code = 0;
      state.authReturnData.value = "";
      state.authReturnData.message = "";
    },
    CHANGE_API_RETURN(state, { response, getters }) {
      state.authReturnData.code = response.code;
      state.authReturnData.value = response.value;
      const errorMessageInfo = getters.errorMessageInfo(response.code);
      if (errorMessageInfo.length > 0) {
        state.authReturnData.message = errorMessageInfo[0].message;
      } else {
        state.authReturnData.message = "인증 중 오류가 발생하였습니다";
      }
    },
    CHANGE_API_ERRROR(state, { getters }) {
      const code = 99999;
      state.authReturnData.code = code;
      state.authReturnData.value = null;
      const errorMessageInfo = getters.errorMessageInfo(code);
      if (errorMessageInfo !== null) {
        state.authReturnData.message = errorMessageInfo[0].message;
      } else {
        state.authReturnData.message = "인증 중 오류가 발생하였습니다";
      }
    },
    SETTING_AUTH_INFO(state, response) {
      if (CommonUtil.isNotEmpty(response.access_token)) state.authInfo.access_token = response.access_token;
      if (CommonUtil.isNotEmpty(response.refresh_token)) state.authInfo.refresh_token = response.refresh_token;
      state.authInfo.expires_in = response.expires_in;
      state.authInfo.refresh_token_expires_in = response.refresh_token_expires_in;
      // etoos 쿠카 생성용 info start
      state.authInfo.authPortalMemNo = response.member_no;
      state.authInfo.authMemNo = response.etoos_member_no;
      state.authInfo.authSessionId = response.session_id;
      state.authInfo.authMemEmailId = response.email_id;
      state.authInfo.authMemMobileId = response.mobile_id;
      state.authInfo.authMemNm = response.name;
      state.authInfo.authAuthKey = response.auth_key;
      state.authInfo.authSocialType = response.social_type;
      state.authInfo.authLoginDt = response.login_date;
      state.authInfo.authEmail = response.email;
      state.authInfo.authPhone = response.phone;
      state.authInfo.authFirstIdType = response.first_id_type;
      state.authInfo.authMemId = response.etoos_id;
      state.authInfo.authEciIsAgree = response.is_eci_agree;
      // etoos 쿠카 생성용 info end
      // zocbo 쿠키 생성용 info start
      state.authInfo.authZocboId = response.zocbo_member_id;
      state.authInfo.authZocboNo = response.zocbo_member_no;
      // zocbo 쿠키 생성용 info end
      // Di-ON 중복 로그인 제한 코드
      if (CommonUtil.isNotEmpty(response.allow_login_key)) {
        state.authInfo.authAllowLoginKey = response.allow_login_key;
      } else {
        state.authInfo.authAllowLoginKey = "";
      }
    },
    INIT_AUTH_ALLOW_LOGIN_KEY(state) {
      state.authInfo.authAllowLoginKey = "";
    },
    SETTING_SSO_AUTH_INFO(state, response) {
      state.authInfo.authPortalMemNo = response.member_no;
      state.authInfo.authMemNo = response.etoos_member_no;
      state.authInfo.authSessionId = response.session_id;
      state.authInfo.authMemEmailId = response.email_id;
      state.authInfo.authMemMobileId = response.mobile_id;
      state.authInfo.authMemNm = response.name;
      state.authInfo.authAuthKey = response.auth_key;
      state.authInfo.authSocialType = response.social_type;
      state.authInfo.authLoginDt = response.login_date;
      state.authInfo.authEmail = response.email;
      state.authInfo.authPhone = response.phone;
      state.authInfo.authFirstIdType = response.first_id_type;
      state.authInfo.authMemId = response.etoos_id;
      state.authInfo.authEciIsAgree = response.is_eci_agree;
      state.authInfo.authZocboId = response.zocbo_member_id;
      state.authInfo.authZocboNo = response.zocbo_member_no;
      state.authInfo.isProfileRequired = response.is_profile_required;
    },
    INIT_ZOCBO_SSO(state) {
      state.authInfo.authZocboSso = "";
    },
    SETTING_ZOCBO_SSO(state, response) {
      console.log("zocbo sso, " + response.zocbosso);
      state.authInfo.authZocboSso = response.zocbosso;
    },
    REMOVE_AUTH_INFO(state) {
      state.authInfo.access_token = "";
      state.authInfo.refresh_token = "";
    },
    SET_AUTH_TOKEN(state, response) {
      state.authInfo.access_token = response.accessToken;
      state.authInfo.refresh_token = response.refreshToken;
    },
    SET_LOGIN_TYPE(state, type) {
      state.serviceAuthInfo.type = type;
    },
    SETTING_SIGNIN_RESULT_CODE(state, code) {
      state.signinReturnCode = code;
    },
    SETTING_TOKEN_CREATE_RESULT_CODE(state, code) {
      state.createTokenReturnCode = code;
    },
    CHANGE_LOGIN_STATE(state, response) {
      //비밀번호 주기적 변경대상
      if (state.signinReturnCode !== 10025) {
        state.serviceAuthInfo.hasLogin = true;
      }
      state.serviceAuthInfo.access_token = response.access_token;
      state.serviceAuthInfo.refresh_token = response.refresh_token;
      state.serviceAuthInfo.expires_in = response.expires_in;

      if (typeof response.refresh_token_expires_in !== "undefined") {
        state.serviceAuthInfo.refresh_token_expires_in = response.refresh_token_expires_in;
      }
    },
    CHANGE_REMOVE_LOGIN_STATE() {
      VueCookies.remove(COOKIE_KEY.LOGIN_COOKIE_ACCESS_TOKEN, "/", Config.COOKIE_DOMAIN);
      VueCookies.remove(COOKIE_KEY.LOGIN_COOKIE_REFRESH_TOKEN, "/", Config.COOKIE_DOMAIN);
      this.commit("INIT_AUTH_INT");
    },
    INIT_AUTH_INT(state) {
      state.authInfo.access_token = "";
      state.authInfo.refresh_token = "";

      state.serviceAuthInfo.type = "";
      state.serviceAuthInfo.hasLogin = false;
      state.serviceAuthInfo.access_token = "";
      state.serviceAuthInfo.refresh_token = "";
      state.serviceAuthInfo.expires_in = "";
      state.serviceAuthInfo.refresh_token_expires_in = "";
    },
    SETTING_BRANCH_TYPE(state, branchType) {
      state.signinInfo.branch_type = branchType;
    },
    SET_SIGNIN_TYPE(state, type) {
      state.signinInfo.type = type;
    },
    SET_ACCOUNT_CODE(state, code) {
      state.accountCode = code;
    }
  }, //데이터 변경
  actions: {
    /**
     * @deprecated 전환로그인 시점부터 사용 안함
     * 영향도 체크완료시 삭제예정
     * authmixin.js 로 코드 옮김
     */
    async signin({ commit, getters, state, dispatch }, payload) {
      console.log("signin start");
      commit("INIT_API_RETURN");

      const xClientInfo = getters.getXClientInfo;
      payload.data.client_id = xClientInfo.ID;
      payload.data.client_secret = xClientInfo.SECRET;

      // payload.data.redirect_uri = state.serviceInfo.redirectUrl;
      payload.data.redirect_uri = state.clientInfo.REDIRECT_URL;
      payload.data.response_type = "code";
      payload.data.callback_state = getters.getRandomString;
      payload.data.login_site = payload.login_site;
      payload.data.captcha_response = payload.captcha_response ?? "";
      payload.data.country_number = "+82";

      const headerOption = {
        "X-Client-Id": xClientInfo.ID,
        "X-Client-Secret": xClientInfo.SECRET,
        "X-Os-Code": getters.getOSCode
      };

      await AuthApi.login(payload.type, payload.data, headerOption)
        .then(async (response) => {
          if (typeof response === "undefined") return;
          const data = response.data;

          if (data.code === 0 || data.code === 10025) {
            commit("SETTING_SIGNIN_INFO", payload);
            commit("SETTING_SIGNIN_RESULT_CODE", data.code);

            ///토큰 생성 api 호출
            const createTokenParam = {
              type: payload.type,
              login_site: payload.login_site,
              data: {
                client_id: xClientInfo.ID,
                client_secret: xClientInfo.SECRET,
                code: data.value.code,
                grant_type: "authorization_code"
              }
            };
            dispatch("createToken", createTokenParam);
          } else {
            const response = {
              code: data.code,
              value: data.value
            };

            /// 휴면, 탈퇴 대기 계정, 전환 대상
            if (data.code === 10006 || data.code === 10005 || data.code === 10008) {
              commit("SETTING_SESSION_TOKEN", data.value.session_token);
            }

            commit("CHANGE_API_RETURN", { response, getters });
          }
        })
        .catch((e) => {
          console.log(e);
          commit("CHANGE_API_ERRROR", { getters });
          return;
        });
    },

    /**
     * @deprecated 전환로그인 시점부터 사용 안함
     * 영향도 체크완료시 삭제예정
     * authmixin.js 로 코드 옮김
     */
    async ssoSignin({ commit, dispatch, getters, state }, ssoParam) {
      console.log("ssoSignin start");
      const payload = state.signinInfo;
      try {
        payload.data.client_id = getters.clientInfo.ID;
        payload.data.client_secret = getters.clientInfo.SECRET;
      } catch (e) {
        commit("CHANGE_API_ERRROR", { getters });
      }

      const xClientInfo = getters.getXClientInfo;
      const headerOption = {
        Authorization: `bearer ${ssoParam.data}`,
        "X-Client-Id": xClientInfo.ID,
        "X-Client-Secret": xClientInfo.SECRET,
        "X-Os-Code": getters.getOSCode
      };

      await AuthApi.ssoSignin(payload.type, payload.data, headerOption)
        .then((response) => {
          if (typeof response === "undefined") return;
          const data = response.data;
          commit("SET_LOGIN_TYPE", payload.type);

          if (data.code === 0) {
            const createTokenParam = {
              headerOption,
              data: {
                client_id: getters.clientInfo.ID,
                client_secret: getters.clientInfo.SECRET,
                code: data.value.code,
                grant_type: "authorization_code"
              }
            };

            dispatch("createServiceToken", createTokenParam);
          } else {
            const response = {
              code: data.code,
              value: data.value
            };
            commit("CHANGE_API_RETURN", { response, getters });
          }
        })
        .catch(() => {
          commit("CHANGE_API_ERRROR", { getters });
        });
    },

    /**
     * @deprecated 전환로그인 시점부터 사용 안함
     * 영향도 체크완료시 삭제예정
     * authmixin.js 로 코드 옮김
     */
    // eslint-disable-next-line no-unused-vars
    async createToken({ commit, dispatch, getters, state }, payload) {
      const headerOption = { "X-Os-Code": getters.getOSCode };

      await AuthApi.createToken(payload.data, headerOption)
        .catch(() => {
          commit("CHANGE_API_ERRROR", { getters });
        })
        .then((response) => {
          if (typeof response === "undefined") return;
          const data = response.data;

          if (data.code === 0) {
            // data.value.scope //계정타입
            const accessToken = data.value.access_token;
            const refreshToken = data.value.refresh_token;
            const cookieData = {
              accessToken,
              refreshToken
            };

            commit("SETTING_AUTH_INFO", cookieData);

            //비밀번호 주기적 변경대상
            if (state.signinReturnCode === 10025) {
              const response = {
                code: 10025,
                value: ""
              };
              commit("CHANGE_API_RETURN", { response, getters });
            } else {
              ///로그인 타입일때만 바로 ssoSignin
              if (payload.login_site !== Config.LOGIN_SITE.JOIN) {
                const ssoParma = {
                  type: payload.type,
                  data: accessToken
                };

                dispatch("ssoSignin", ssoParma);
              }
            }
          } else {
            const response = {
              code: data.code,
              value: data.value
            };
            commit("CHANGE_API_RETURN", { response, getters });
          }
        });
    },
    // eslint-disable-next-line no-unused-vars
    async createServiceToken({ commit, getters, state }, payload) {
      console.log("create service token start");
      await AuthApi.ssoCreateToken(payload.data, payload.headerOption)
        .catch(() => {
          commit("CHANGE_API_ERRROR", { getters });
        })
        .then((response) => {
          if (typeof response === "undefined") return;
          const data = response.data;
          if (data.code === 0) {
            commit("CHANGE_LOGIN_STATE", data.value);
          } else {
            const response = {
              code: data.code,
              value: data.value
            };
            commit("CHANGE_API_RETURN", { response, getters });
          }
        });
    },
    async localCreateToken({ commit, getters, state }) {
      const header = {
        "X-Client-Id": getters.clientInfo.ID,
        "X-Os-Code": getters.getOSCode
      };

      const payload = {
        client_id: getters.clientInfo.ID,
        client_secret: getters.clientInfo.SECRET,
        session_token: state.sessionToken,
        grant_type: "token"
      };
      return AuthApi.localCreateToken(payload, header).then((response) => {
        if (typeof response === "undefined") return;
        const data = response.data;
        if (data.code === 0) {
          commit("CHANGE_LOGIN_STATE", data.value);
          return response.data;
        } else {
          throw new Error(data.code);
        }
      });
    },
    async refreshToken({ commit, getters }, refreshToken) {
      const param = {
        refresh_token: refreshToken,
        client_id: getters.clientInfo.ID,
        client_secret: getters.clientInfo.SECRET,
        grant_type: "refresh_token"
      };

      const headerOption = {
        "X-Os-Code": getters.getOSCode
      };

      return AuthApi.refreshToken(param, headerOption)
        .then((response) => {
          if (typeof response === "undefined") return;
          const data = response.data;
          if (data.code === 0) {
            commit("CHANGE_LOGIN_STATE", data.value);
          } else {
            const response = {
              code: data.code,
              value: data.value
            };
            commit("CHANGE_API_RETURN", { response, getters });
          }
        })
        .catch(() => {
          commit("CHANGE_API_ERRROR", { getters });
        });
    },
    async validationToken({ commit, getters }, payload) {
      const accessToken = payload.accessToken;
      const refreshToken = payload.refreshToken;

      const header = {
        Authorization: `bearer ${accessToken}`,
        "X-Client-Id": getters.clientInfo.ID,
        "X-Os-Code": getters.getOSCode,
        "X-Client-Version": ENCRYPTION_VERSION,
        "X-Client-Service": commonUtil.getServiceMappingKey(getters.clientInfo.SERVICE_CODE)
      };

      return await AuthApi.validToken(header)
        .then(async (response) => {
          if (typeof response === "undefined") return;
          const data = response.data;
          if (data.code === 0) {
            const returnValue = {
              access_token: accessToken,
              refresh_token: refreshToken,
              expires_in: data.value.expires_in
            };
            commit("CHANGE_LOGIN_STATE", returnValue);
          } else {
            const response = {
              code: data.code,
              value: ""
            };
            commit("CHANGE_API_RETURN", { response, getters });
          }
        })
        .catch((e) => {
          console.log(e);
          commit("CHANGE_API_ERRROR", { getters });
        });
    }
  }
};
